<template>
	<page enable-flex :create-button="auth('b_app_inventory_create')" @create="mp.navigateWeb('/stock/check/create')">
		<view-list ref="view" work-type="29">
			<template #filter>
				<m-search>
					<m-search-item label="盘点单号">
						<c-input name="check_code" placeholder="请输入盘点单号"></c-input>
					</m-search-item>
					<m-search-item label="盘点人员">
						<c-input name="check_user" placeholder="请输入盘点人员"></c-input>
					</m-search-item>
					<m-search-item label="盘点结果">
						<c-select name="check_result" async @search="searchInventoryResult"></c-select>
					</m-search-item>
					<m-search-item label="创建时间" colspan="2">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template>

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data">
					<template #number>
						{{data.check_code}}
					</template>

					<template #state>
						<c-state dict="INVENTORY_STATE" :value="data.check_state" type="state"></c-state>
					</template>

					<template #default>
						<c-field label="盘点人员">{{data.check_user_name}}</c-field>
						<c-field v-if="data.check_result" label="盘点结果">
							<c-state dict="INVENTORY_RESULT" :value="data.check_result"></c-state>
						</c-field>
						<c-field label="备注">
							<template v-if="data.check_result == 2">
								[<span class="profit-loss-count">盘亏{{data.loss_count || 0}}条，盘盈{{data.profit_count || 0}}条</span>]<template v-if="data.remark"> {{data.remark}}</template>
							</template>
							<template v-else>{{data.remark || '-'}}</template>
						</c-field>
						<c-field label="创建时间">{{data.create_date}}</c-field>
					</template>

					<template #operate>
						<c-button v-if="data.check_state != 3 && (userInfo.id == data.create_user_id || userInfo.id == data.check_user_id) && auth('b_app_inventory_start')" color="main" hollow @click="mp.navigateWeb('/stock/check/do', {id: data.id})">开始盘点</c-button>
						<c-button v-if="data.check_state == 3 && auth('b_app_inventory_view')" @click="mp.navigateWeb('/stock/check/detail', {id: data.id})">查看</c-button>
                        <c-button v-if="userInfo.id == data.create_user_id && data.check_state == 1 && auth('b_app_inventory_delete')" @click="deleteHandle(data)">删除</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
			}
		},

		computed: {
			...mapState(['userInfo'])
		},
		
		methods: {
			searchInventoryResult(keyword, resolve) {
				this.request({
					url: '/system/dic/options',
					data: {
						dic_type_code: 'INVENTORY_RESULT',
						keyword: keyword
					},
					success: data => {
						resolve(data || []);
					}
				});
			},

			deleteHandle(data) {
				this.$confirm({
					message: '确认删除该盘点任务吗？',
					resolve: () => {
						this.request({
							url: '/inventory/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									message: '删除成功'
								});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.profit-loss-count {
		color: #e53e3e;
	}
</style>